import Client from './client';

export default class LabProjectSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/lab/project/settings`, options);
  }

  getByFlowLabProjectKey(organization, flowLabProjectKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/lab/project/settings/${flowLabProjectKey}`, options);
  }

  putByFlowLabProjectKey(organization, flowLabProjectKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/lab/project/settings/${flowLabProjectKey}`, {
      ...options,
       method: 'PUT',
    });
  }

}
